// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CodeOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CodeOffIcon" ref={forwardedRef} {...props}>
      <path d="M14.56 9.682 14.88 10l-3.182 3.182 1.06 1.061L17 10l-1.379-1.378z" />
      <path d="m13.5 6.5-.743-.742-1.06 1.06.742.743z" />
      <path d="M7.56 12.44 5.121 10l3.182-3.182-1.06-1.06L3 10l3.5 3.5z" />
      <path d="M4.75 15.25 16.064 3.936l1.06 1.06L5.811 16.312z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CodeOffIcon = /* @__PURE__ */ Object.assign(CodeOffIconComponent, {
  displayName: 'CodeOffIcon',
});
